/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_DubbingInputs */



/**
* | output |
* | --- |
* | "Audio Dubbing" |
*
* @param {Audio_DubbingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_dubbing = /** @type {((inputs?: Audio_DubbingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_DubbingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Doublage audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Synchronisation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppiaggio audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиодубляж")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doblaje de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频配音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声吹き替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो डबिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dobragem de áudio")
	return /** @type {LocalizedString} */ ("Audio Dubbing")
});